module.exports = __webpack_public_path__ + "img/achillea_millefeuille.6fedf21a.jpg";